import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { State, InvestorLiabilitiesModel } from 'models';

import services from 'services';

import { LiabilitiesAddonDetails } from 'components';

interface LiabilitiesAddonState {
  investorLiabilities: InvestorLiabilitiesModel;
  loading: boolean;
  error: boolean;
}

const LiabilitiesAddon = () => {
  const { coopId } = useSelector((state: State) => ({
    coopId: state.settings.current_cooperative,
  }));
  const [state, setState] = useState<LiabilitiesAddonState>({
    investorLiabilities: {
      BalanceAmount: 0,
      InHand: 0,
      TotalAmount: 0,
    },
    loading: false,
    error: false,
  });

  useEffect(() => {
    (async function () {
      try {
        setState((prevState) => ({
          ...prevState,
          loading: true,
          error: false,
        }));

        const investorLiabilities: InvestorLiabilitiesModel = (
          await services.get(`/api/portfolios/${coopId}/dashboard/liabilities`)
        ).data.Data;

        setState((prevState) => ({
          ...prevState,
          loading: false,
          investorLiabilities,
        }));
      } catch (err) {
        console.error(err);
        setState((prevState) => ({
          ...prevState,
          loading: false,
          error: true,
        }));
      }
    })();
  }, [coopId]);

  return <LiabilitiesAddonDetails {...state} />;
};

export default LiabilitiesAddon;
